import { render, staticRenderFns } from "./RptPremios.vue?vue&type=template&id=4712e0f1&"
import script from "./RptPremios.vue?vue&type=script&lang=js&"
export * from "./RptPremios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports